import { render, staticRenderFns } from "./c-kbk-selector.vue?vue&type=template&id=61700c3d&scoped=true&"
import script from "./c-kbk-selector.vue?vue&type=script&lang=ts&"
export * from "./c-kbk-selector.vue?vue&type=script&lang=ts&"
import style0 from "./c-kbk-selector.vue?vue&type=style&index=0&id=61700c3d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61700c3d",
  null
  
)

export default component.exports